// import axios from "axios";
// import Cookies from "js-cookie";

// const apiInstance = axios.create({
//   baseURL: process.env.REACT_APP_AXIOS_API,
// });

// apiInstance.interceptors.request.use((config) => {
//   const theKey = Cookies.get("kalista-webtoken");
//   console.log("Token :", theKey);

//   if (theKey) {
//     config.headers["Authorization"] = `Bearer ${theKey}`;
//   }

//   return config;
// });

// export { apiInstance };


// helpers/axios.js
import axios from "axios";
import Cookies from "js-cookie";

let dynamicToken = null;
export const setDynamicToken = (token) => {
  dynamicToken = token;
};

const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_AXIOS_API,
});

apiInstance.interceptors.request.use((config) => {
  const cookieToken = Cookies.get("kalista-webtoken");

  if (dynamicToken) {
    config.headers["Authorization"] = `Bearer ${dynamicToken}`;
  } else if (cookieToken) {
    config.headers["Authorization"] = `Bearer ${cookieToken}`;
  }

  return config;
});

export { apiInstance };
